import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: {
    bg: 'bg-primary-50 border-primary-200 hover:border-primary-400',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
  },
  accent: {
    bg: 'bg-accent-50 border-accent-200 hover:border-accent-400',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
  },
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大精选分类，总有一款适合您的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} border rounded-xl p-5 flex flex-col items-center text-center gap-3 transition-all duration-300 no-underline cursor-pointer group`}
              >
                <div
                  className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center ${colors.iconBg} rounded-xl ${colors.text} group-hover:scale-110 transition-transform duration-300`}
                >
                  <i className={`${cat.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2">
                    {cat.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}